import { VectiResult } from "~/context/Shared/domain/VectiResult";
import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { CompanyAlertRepository } from "../domain/CompanyAlertRepository";

export function createApiCompanyAlertRepository(): CompanyAlertRepository {
  return new APICompanyAlertRepository();
}

export class APICompanyAlertRepository
  extends APIRepository
  implements CompanyAlertRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  async listAlertsByCompany(companyId: string): Promise<VectiResult> {
    try {
      console.log("listAlertsByCompany Repository API: " + companyId);
      //const response = await this.doGet<Document>("/api/documents/full/bestmatch/company/" + companyId?.toString() + "/movement/" + movementId?.toString() + "/tolerance/" + tolerance?.toString());
        const response = await this.doGet("/api/companies/alerts/" + companyId?.toString());
//      console.log("addCreditCardFile resp:" + JSON.stringify(resp));
      return new VectiResult(true, response);
    } catch (error) {
      console.log("error addCreditCardFile X:" + error);
      return new VectiResult(false, "Error: " + error);
    }
  }


  async dissmissCompanyAlert(companyAlertId:string, companyId: string): Promise<VectiResult> {
    try {
      console.log("dissmissCompanyAlert Repository API: " + companyId);
      //const response = await this.doGet<Document>("/api/documents/full/bestmatch/company/" + companyId?.toString() + "/movement/" + movementId?.toString() + "/tolerance/" + tolerance?.toString());
        const response = await this.doGet("/api/companies/"+ companyId?.toString() + "/alerts/dismiss/" + companyAlertId?.toString());
//      console.log("addCreditCardFile resp:" + JSON.stringify(resp));
      return new VectiResult(true, response);
    } catch (error) {
      console.log("error dissmissCompanyAlert:" + error);
      return new VectiResult(false, "Error: " + error);
    }
  }



  }